import IMAGES from "../../../../assets/images/images.js";
import { getLogo } from "../../../../utils/constants/fileTypeLogo.js";
import { STATUS_STYLES } from "./progressIndicator.config.js";
import styles from "./progressIndicator.module.css";

export const ProgressIndicator = ({
  status,
  demandId,
  onBackToReview,
  header,
  text,
  bgColor,
  borderColor,
  titleColor,
  textColor,
}) => {
  const dynamic = STATUS_STYLES[status] || {};

  return (
    <div className={styles.wrapper}>
      <div
        className={styles.panel}
        style={{
          backgroundColor: bgColor || dynamic.bgColor,
          borderColor: borderColor || dynamic.borderColor,
        }}
      >
        <div className={styles.details}>
          <div className={styles.header}>
            <div
              className={styles.title}
              style={{ color: titleColor || dynamic.titleColor }}
            >
              {header}
            </div>
          </div>
          <div
            className={styles.content}
            style={{ color: textColor || dynamic.textColor }}
          >
            <div className={styles.text}>
              {text} <strong>{demandId}</strong>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const ReportIndicatorPanel = ({text,type=null,data, onFileDownload,downloadAccess=false }) => {
  const downloadFile = (file, index, onDownload) => {
    onDownload(file)
  }

  return (
    <div className={`${data?.comment ? styles.feasibilityContainer :styles.wrapper}`}>
      {data?.files?.length >0 &&
      <div className={styles.feasibilitysub}>
        <div className={styles.feasibilitytext}>
          <div><img className={styles.fileIcon} src={IMAGES.attachmenticon} /></div>
          <div className={styles.comment}>{text}</div>
          {
            type && (<span className={styles.reportStatus}>{type}</span>)
          }
        </div>
        <div className={styles.reportdownload}>
          {data?.files?.length > 0 && downloadAccess ?
            <div className={styles.attachmentCont}>
              {data?.files?.map((item, index) =>
                <div className={styles.attachment}  onClick={() => downloadFile(item, index, onFileDownload)} key={index} title={"Download Report"}>
                   <img className={styles.attachlogos} src={IMAGES.downloadWhite}/><span  className={styles.attachtext} >Download</span>
                </div>
              )}
            </div>
            : ''}
        </div>
      </div>}
      {data?.comment  &&<>
       <div className={`${styles.commentlabel} ${data?.files?.length && data?.comment  ? styles.addline :"" }`}>Comment</div>
       <div className={styles.commenttxt}>{data?.comment ?.split('\n').map(text => <div>{text}</div>)}</div></>}
    </div>
  );
};

export const StatusCallout =({sectionTitle,sectionHelpText,onSectionHelpClick,title,description,variant = "warning",icon,className = "",compact = false,classStyle=''})=> {
  const regionId = `status-${Math.random().toString(36).slice(2)}`;
  const titleId = `${regionId}-title`;
  const sectionLabelId = sectionTitle ? `${regionId}-section-title` : undefined;
  const DocIcon = <img className={styles.circleinfo} src={IMAGES.attachmenticon}/>
  // (
  //   <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true" className={styles.iconSvg}>
  //     <path fill="currentColor" d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8Zm0 0v6h6"/>
  //   </svg>
  // );
  const InfoIcon = <img className={styles.circleinfo} src={IMAGES.infoCircle}/>
  return (
    <section role="region" aria-labelledby={sectionLabelId || titleId} className={`${styles.wrapper} ${className}`}>
      {/* {sectionTitle ? (
        <div className={styles.sectionHeader}>
          <div id={sectionLabelId} className={styles.sectionTitle}>{sectionTitle}</div>
          {sectionHelpText ? (<button type="button" className={styles.helpBtn} aria-label="More info" title={sectionHelpText} onClick={onSectionHelpClick}>{InfoIcon}</button>) : null}
        </div>
      ) : null} */}
      <div className={`${styles.callout} ${classStyle} ${styles[variant]} ${compact ? styles.compact : ""}`} role="status" aria-live="polite">
        <div className={styles.iconCol} aria-hidden="true">{icon&&<img className={styles.circleinfo} src={icon}/>}</div>
        <div className={styles.bodyCol}>
          <div id={titleId} className={styles.calloutTitle}>{title}</div>
          {description ? <div className={styles.calloutDesc}>{description.split('\n').map(item=> <div>{item}</div>)}</div> : null}
        </div>
      </div>
    </section>
  );
}
export default StatusCallout;


export const QuotationStatus =({sectionTitle,sectionHelpText,onSectionHelpClick,title,description,variant = "warning",icon,className = "",compact = false,})=> {
  const regionId = `status-${Math.random().toString(36).slice(2)}`;
  const titleId = `${regionId}-title`;
  const sectionLabelId = sectionTitle ? `${regionId}-section-title` : undefined;
  return (
    <section role="region" aria-labelledby={sectionLabelId || titleId} className={`${styles.quotewrapper} ${className}`}>
      <div className={`${styles.quotecallout} ${styles[variant]} ${compact ? styles.compact : ""}`} role="status" aria-live="polite">
        <div className={styles.bodyCol}>
          <div id={titleId} className={styles.calloutTitle}>{title}</div>
          {description ? <div className={styles.calloutDesc}>{description?.split('\n').map(text => <div>{text}</div>)}</div> : null}
        </div>
      </div>
    </section>
  );
}